import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/fwb.css';
import Bubble from '../components/Bubble';

const FWB = () => {
  const { t } = useTranslation();
  // Estado para detectar si es vista móvil
  const [isMobile, setIsMobile] = useState(false);

  // Detectar el tamaño de pantalla
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    // Comprobar al cargar
    checkMobile();
    
    // Comprobar al cambiar tamaño de ventana
    window.addEventListener('resize', checkMobile);
    
    // Limpiar evento al desmontar
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  return (
    <div className="fwb-page">
      <h1 className="fwb-title" style={{
        marginTop: isMobile ? '-120px' : null 
      }}>{t('fwb.page.title')}</h1>
      
      {/* Espacio adicional entre el título y las burbujas */}
      <div style={{ marginTop: '60px' }}></div>
      
      <div style={{ 
        display: 'flex', 
        flexDirection: 'column', 
        gap: '25px', 
        padding: '15px',
        marginBottom: '40px'
      }}>
        {/* Primera fila: Burbujas 1 y 4 (antes era 2) */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 1: Introducción (sin cambios) */}
          <Bubble 
            className="bubble-1"
            title="Comunidad eDOP (FWB)"
            content="En eDOP, creemos en una comunidad global que busca
            democratizar el acceso financiero. Nuestro ecosistema está
            diseñado para que los usuarios tomen el control y colaboren
            hacia una economía digital más equitativa, especialmente en
            mercados emergentes."
            translationKey="bubbles.fwb.community"
            color="blue"
            position="center"
            size="medium"
          />

          {/* Burbuja 4: Actualizaciones Recientes (antes era Burbuja 2) */}
          <Bubble 
            className="bubble-2"
            title="Cómo Unirse y Participar"
            content={
              <div>
                <p>Forma parte activa de eDOP usando el token para pagos,
                  participando en nuestro programa de staking para apoyar
                  la red, y preparándote para contribuir en la futura gobernanza
                  del ecosistema. Tu participación es clave para nuestro crecimiento.</p>
                
              </div>
            }
            translationKey="bubbles.fwb.join"
            date="Fecha: 04 de abril de 2025"
            color="purple"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Espacio adicional entre filas de burbujas */}
        <div style={{ marginTop: '60px' }}></div>

        {/* Segunda fila: Burbujas 3 y 2 (antes era 4) */}
        <div style={{ 
          display: 'flex', 
          flexDirection: 'row',
          justifyContent: 'space-between',
          gap: '20px', 
          flexWrap: 'wrap'
        }}>
          {/* Burbuja 3: Cómo Unirse (sin cambios) */}
          <Bubble 
            className="bubble-3"
            title="Beneficios de la Comunidad eDOP"
            content={
              <ul>
                <li>Al participar en eDOP, puedes obtener recompensas periódicas
                  a través del staking (provenientes del 30% del suministro total
                  asignado). Además, la tenencia activa puede darte acceso a beneficios
                  como descuentos en tarifas o prioridad en nuevas funciones del ecosistema.</li>
              </ul>
            }
            translationKey="bubbles.fwb.benefits"
            color="orange"
            position="center"
            size="medium"
          />

          {/* Burbuja 2: Beneficios (antes era Burbuja 4) */}
          <Bubble 
            className="bubble-4"
            title="Conéctate con la Comunidad"
            content="Mantente informado y conectado con el proyecto eDOP.
            Encuentra los enlaces a nuestros canales comunitarios oficiales,
            documentación técnica y formas de contacto directamente en nuestro
            sitio web oficial."             
            translationKey="bubbles.fwb.connect"
            color="green"
            position="center"
            size="medium"
          />
        </div>
        
        {/* Espacio adicional entre filas de burbujas */}
        <div style={{ marginTop: '60px' }}></div>

        {/* Tercera fila: Burbuja 5 (sin cambios) */}
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center',
          width: '100%'
        }}>
          {/* Burbuja 5: Nuevo Canal Comunitario */}
         
        </div>
      </div>
    </div>
  );
};

export default FWB;
